<template>
  <div class="">
    <div id="mapChart" style="width: 100%;height:48vh;"></div>
  </div>
</template>

<script>
import '../../node_modules/echarts/map/js/china.js' // 引入中国地图数据
import {mapClickData, mapHoverData} from '../api/home'

var _this = this
var timmerMap = null;
export default {
  name: "mapChart",
  data() {
    return {
      myChart: null,
      timer: null,
      chartData: [
        // {
        //   "area": "北京",
        //   "board_num": "8",
        //   "ask_num": "14",
        //   "sign_num": "1"
        // },
      ],
      cityName: ['河北', '山西', '辽宁', '吉林', '黑龙江', '江苏', '浙江', '安徽', '福建',
        '江西', '山东', '河南', '湖北', '湖南', '广东', '海南', '四川', '贵州', '云南',
        '陕西', '甘肃', '青海', '台湾', '北京', '天津', '上海', '重庆', '内蒙古', '广西', '西藏', '宁夏', '新疆','香港','澳门'],
      hoverData: [],
      option: {
        tooltip: {
          trigger: 'item',
          backgroundColor: '#ffffff',
          padding: [5, 0],
          // position: 'inside',
          textStyle: {
            color: "#333"
          },
          formatter: (params) => {   // 鼠标滑过显示的数据
            let showText = '';
            if (params.data) {
              showText += `<div style="background: #fff;">
                              <div style="color:#333;font-size:15px;padding:5px;border-bottom: 1px solid #333;">${params.data.name}</div>
                                  <div style="padding:1px 8px;">在线:<span style="color:green;display: inline-block;padding:0 5px;">${params.data.cityData.online || 0}</span>台  离线:<span style="color:#ff0000;display: inline-block;padding:0 5px;">${params.data.cityData.offline || 0}</span>台</div>
                              </div>
                            </div>
                            `
              return showText
            } else {
              showText = `<div style="padding: 5px 10px;">暂无此地区数据</div>`
              return showText
            }
          }
        },
        series: [{
          type: 'map',
          map: 'china',
          tooltip: {
            show: true
          },
          data: [],
          label: {
            // show: true,
            // color: '#FFFFFF',
            // fontSize: 8
          },
          aspectScale: 0.96,
          layoutCenter: ["50%", "50%"], //地图位置
          layoutSize: '140%',//地图大小
          roam: true,
          geoIndex: 0,
          itemStyle: {
            normal: {
              borderColor: '#14ABAF',//地图的边界线颜色
              borderWidth: 0.9,
              areaColor: '#041A66',
              textStyle: {
                color: '#fff'
              }
            },
            emphasis: {//鼠标移入高亮颜色
              areaColor: '#1194A3',//地图色
            }
          },
          zlevel: 1
        }]
      },
    }
  },
  mounted() {
    this.mapHoverDataHandle() //调取地图鼠标悬浮的 全部省份数据
    this.timer = setInterval(() => {
      this.mapHoverDataHandle() //调取地图鼠标悬浮的 全部省份数据
    },2000)
  },
  destroyed() {
    clearInterval(this.timer)
    this.myChart.dispose() //销毁echarts 实例
  },
  methods: {
    init() {
      this.myChart = this.$echarts.init(document.getElementById('mapChart'));
      this.option.series[0].data = this.chartData
      this.myChart.setOption(this.option);
      var myChart = this.myChart
      //点击事件,根据点击某个省份计算出这个省份的数据
      myChart.on('click', (params) => {
        if (params.data && params.data.name) {
          this.hoverData.forEach(item => {
            if (item.provinceName.indexOf(params.data.name) !== -1) {
              this.$emit('mapChange', item.provinceName) //子组件触发点击事件 把省份名传递出去 父组件监听使用
            }
          })
        }
        //逻辑控制
      });
    },
    //地图悬浮显示的数据mapClickData, mapHoverData
    mapHoverDataHandle() {
      mapHoverData({
        jsessionId: sessionStorage.token,
        geoPcc: '',
      }).then(res => {
        if (res.data.code === 0) {
          if(JSON.stringify(res.data.data) != JSON.stringify(this.hoverData)){
            this.hoverData = res.data.data
            this.hoverData.forEach((item, index) => {
              this.cityName.forEach((city, cityIndex) => {
                if (item.provinceName.indexOf(city) !== -1) {
                  let _cityData = {
                    offline:item.cityData.offline,
                    online:item.cityData.online,
                  }
                  this.chartData.push(
                      {
                        "name": city,
                        "selected": true,
                        "cityData": _cityData
                      }
                  )
                }
              })
            })
            this.init()
          }
        }
      }).catch(err => {

      })
    },
    resizeChart() {
      this.myChart.resize()
    }
  }
}
</script>

<style scoped>

</style>
